// api
import { useGetBalanceQuery } from "src/api";

// ----------------------------------------------------------------------

export function useBillingBalance() {
    const { data = {}, isLoading, error } = useGetBalanceQuery(undefined, {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true
    });

    return {
        balance: data?.balance ?? 0,
        //
        loading: isLoading,
        error
    };
}
